import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Popconfirm, Tabs, Select, Drawer, notification,
  Tooltip,
  Divider,
} from 'antd';
import PropTypes from 'prop-types';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import TenantActions from '@Actions/tenantActions';
import UserActions from '@Actions/userActions';
import H3Text from '@Uilib/h3Text';
import {
  EditOutlined, MailOutlined, PhoneOutlined,
} from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import { CountryCodes } from '@Apis/constants';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import AddUser from './AddUser';
import UpdateUser from './UpdateUser';
import UserForm from './UserForm';
import Roles from './Roles';
import ListDepartment from './Department/ListDepartment';
import ListMaskingPolicies from './DataMaskingPolicies/ListMaskingPolicies';

import useCheckPortrait from '../../../hooks/useCheckPortrait';
import PRZText from '../../Common/UI/PRZText';
import './style.scss';
import PRZSelect from '../../Common/UI/PRZSelect';

const { TabPane } = Tabs;
const { Option } = Select;

/**
 *
 */

function withCustomHook(WrappedComponent) {
  return function Wrapper(props) {
    const useCheckPortraitCustomHook = useCheckPortrait();
    return <WrappedComponent {...props} customHooks={{ useCheckPortraitCustomHook }} />;
  };
}
class ManageRole extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const { customHooks, user } = props;

    const {
      isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
    } = customHooks.useCheckPortraitCustomHook;

    this.state = {
      rolecolumns: [
        // {
        //   title: '',
        //   render: (record) => (
        //     <div onClick={() => this.setState({
        //       showUpdateRoleModal: true,
        //       selectedUser: record,
        //     })}
        //     >
        //       <div className="mobile-list__item">
        //         <div style={{ display: 'flex' }}>
        //           <div>
        //             <div
        //               style={{
        //                 fontWeight: '600', fontSize: '12px', cursor: 'pointer',
        //               }}
        //             >
        //               {`${record.first_name ? record.first_name : ''} ${record.last_name ? record.last_name : ''} (${record.tenant_role_name || '-'})`}
        //             </div>
        //           </div>
        //           <div className={`mobile-list__item-status ${record?.is_active ? 'status-tag' : 'status-tag__inactive'}`}>
        //             {record?.is_active ? 'Active' : 'Inactive'}
        //             {' '}
        //           </div>
        //         </div>
        //         <H3Text text={`Designation - ${record?.designation || '0'}`} className="mobile-list__item-info" />
        //         {record.username && (
        //           <div className="mobile-list__item-info">
        //             <div><MailOutlined /></div>
        //             <div style={{ marginLeft: '5px', marginTop: '2px' }}>{`${record.username || '-'}`}</div>
        //           </div>
        //         )}
        //         {record.mobile && (
        //           <div className="mobile-list__item-info">
        //             <div><PhoneOutlined /></div>
        //             <div style={{ marginLeft: '5px', marginTop: '2px' }}>{`${record.mobile || '-'}`}</div>
        //           </div>
        //         )}
        //       </div>
        //     </div>
        //   ),
        //   // responsive: ['xs'],
        //   hidden: !isMobile,
        // },
        {
          title: '',
          render: (record) => (
            <div className="mobile-list__card">
              <div className="mobile-list__card_header">
                <div className="mobile-list__card_header-left">
                  <PRZText
                    text={`${record.first_name ? record.first_name : ''} ${record.last_name ? record.last_name : ''} (${record.tenant_role_name || '-'})`}
                    className="mobile-list__card_item-number"
                  />

                </div>
                <div className="mobile-list__card_header-right">
                  {record?.product_type?.toUpperCase() !== 'SERVICE' && (
                    <PRZText
                      text={record?.is_active ? 'Active' : 'Inactive'}
                      className={`mobile-list__card__status ${record?.is_active ? 'status-tag' : 'status-tag__inactive'}`}
                    />
                  )}
                </div>
              </div>
              <div className="mobile-list__card_body">
                <div className="mobile-list__card_body-left">

                  <Tooltip
                    title={(
                      <PRZText
                        className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                        text={`Designation: ${record?.designation || '-'}`}
                      />
                    )}
                    color="white"
                  >
                    <PRZText text={`Designation: ${record?.designation || '-'}`} className="mobile-list__card_item-details" />
                  </Tooltip>

                  {record.username && (
                    <PRZText
                      className="mobile-list__card_item-details"
                      text={(
                        <span style={{
                          display: 'flex', alignItems: 'center', gap: '5px',
                        }}
                        >
                          <div><MailOutlined /></div>
                          <span>{record.username || '-'}</span>
                        </span>
                      )}
                    />
                  )}

                  {record.mobile && (
                    <PRZText
                      className="mobile-list__card_item-details"
                      text={(
                        <span style={{
                          display: 'flex', alignItems: 'center', gap: '5px',
                        }}
                        >
                          <div><PhoneOutlined /></div>
                          <span>{record.mobile || '-'}</span>
                        </span>
                      )}
                    />
                  )}
                </div>
              </div>

              <Divider className="mobile-list__card_divider" />

              <div className="mobile-list__card_footer">
                <div className="mobile-list__card_footer-left" style={{ width: '100%', paddingTop: '2px' }}>
                  <div className="mobile-list__card_footer__actions-button_wrapper user-list__actions">
                    {Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT,
                      Helpers.permissionTypes.UPDATE, user) && (
                      <Popconfirm
                        placement="topLeft"
                        title={`Are you sure you want to ${record?.is_active ? 'deactivate' : 'activate'} this user?`}
                        onConfirm={() => {
                          const {
                            updateUser, getUsers,
                          } = this.props;
                          updateUser([{
                            tenant_id: user?.tenant_info?.tenant_id,
                            is_active: !record?.is_active,
                            user_id: record?.user_id,
                          }], () => {
                            getUsers(user?.tenant_info?.tenant_id);
                          });
                        }}
                        okText="Yes"
                        cancelText="No"
                      >
                        <div
                          className={`${record?.is_active ? 'user-list__button-inactive' : 'user-list__button'}`}
                        >
                          {record?.is_active ? 'Deactivate' : 'Activate'}
                        </div>
                      </Popconfirm>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ),
          // responsive: ['xs'],
          hidden: !isMobile,
        },
        {
          title: 'MEMBER NAME',
          render: (text, record) => (
            <div className="column-number__wrapper">
              <H3Text text={`${record.first_name ? record.first_name : ''} ${record.last_name ? record.last_name : ''}`} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
        },
        {
          title: 'ROLE',
          render: (text, record) => (
            <div>
              <H3Text text={record.tenant_role_name || '-'} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
        },
        {
          title: 'STATUS',
          render: (text, record) => (
            <H3Text text={record?.is_active ? 'Active' : 'Inactive'} className={record?.is_active ? 'status-tag' : 'status-tag__inactive'} />
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
        },
        {
          title: 'PHONE',
          render: (text, record) => (
            <div>
              <H3Text text={record?.mobile ? (`${CountryCodes?.find((code) => code?.dial_code == record?.dial_code)?.flag} +${record?.dial_code} ${record.mobile}`) : '-'} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
        },
        {
          title: 'DESIGNATION',
          render: (text, record) => (
            <H3Text text={record.designation ? record.designation : 'Not Assigned'} />
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
        },
        {
          title: 'EMAIL',
          render: (text, record) => (
            <H3Text text={record.username ? record.username : '-'} />
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
        },
        {
          title: '',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <div className="user-list__actions">
                {Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT,
                  Helpers.permissionTypes.UPDATE, user) && (
                  <div
                    className="roundIconButton"
                    onClick={() => this.setState({
                      showUpdateRoleModal: true,
                      selectedUser: record,
                    })}
                  >
                    <EditOutlined />
                  </div>
                )}
                {Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT,
                  Helpers.permissionTypes.UPDATE, user) && (
                  <Popconfirm
                    placement="topLeft"
                    title={`Are you sure you want to ${record?.is_active ? 'deactivate' : 'activate'} this user?`}
                    onConfirm={() => {
                      const {
                        updateUser, getUsers,
                      } = this.props;
                      updateUser([{
                        tenant_id: user?.tenant_info?.tenant_id,
                        is_active: !record?.is_active,
                        user_id: record?.user_id,
                      }], () => {
                        getUsers(user?.tenant_info?.tenant_id);
                      });
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <div
                      className={`${record?.is_active ? 'user-list__button-inactive' : 'user-list__button'}`}
                    >
                      {record?.is_active ? 'Deactivate' : 'Activate'}
                    </div>
                  </Popconfirm>
                )}
              </div>
            );
          },
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
        },
      ].filter((item) => !item.hidden),
      showNewRoleModal: false,
      showUpdateRoleModal: false,
      key: '/manage-users',

    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      user, getUsers, history, getRoles,
    } = this.props;
    getUsers(user?.tenant_info?.tenant_id);
    getRoles(user?.tenant_info?.tenant_id);
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    const { location } = props;
    const key = new URLSearchParams(location.search).get('key');
    return {
      ...state,
      key: key || '/manage-users',
    };
  }

  /**
   * @param key
   */
  onTabChange(key) {
    const { history } = this.props;
    this.setState({ key });
    history.push(`?key=${key}`);
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      getUsers, user, getUsersLoading, users, updateUserLoading, roles, getRolesLoading, getUserProfile,
    } = this.props;
    const {
      rolecolumns, showNewRoleModal, showUpdateRoleModal, selectedUser, uniqueRoles, selectedRole,
      key,
    } = this.state;
    return (
      <Fragment>
        <Drawer
          open={showNewRoleModal}
          onClose={() => this.setState({ showNewRoleModal: false })}
          width="320px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '270px' }}>
              <H3Text text="Add New User" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewRoleModal: false })} />
            </div>
          </div>
          <UserForm
            setShowNewOfferModal={(value) => this.setState({ showNewRoleModal: value })}
            callback={() => {
              this.setState({ showNewRoleModal: false });
              getUsers(user?.tenant_info?.tenant_id);
            }}
            uniqueRoles={uniqueRoles}
          // locked={user?.tenant_info?.global_config?.settings?.user_limit >= users?.data?.[0]?.tenant_user?.length}
          />
        </Drawer>
        <Drawer
          open={showUpdateRoleModal}
          onClose={() => this.setState({ showUpdateRoleModal: false })}
          destroyOnClose
          width="320px"
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '270px' }}>
              <H3Text text="Update User" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showUpdateRoleModal: false })} />
            </div>
          </div>
          <UserForm
            setShowNewOfferModal={(value) => this.setState({ showNewRoleModal: value })}
            callback={
              () => {
                this.setState({ showUpdateRoleModal: false });
                getUsers(user?.tenant_info?.tenant_id);
                getUserProfile();
              }
            }
            selectedUser={selectedUser}
          />
        </Drawer>
        <div className="doc-list__tabs-wrapper">
          <div className="ant-row">
            <div className="ant-col-md-24 ant-col-xs-24">
              <Tabs activeKey={key?.toString()} onChange={(f) => this.onTabChange(f)}>
                {Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user) && (
                  <TabPane tab="Users" key="/manage-users" />
                )}
                {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.READ, user) && (
                  <TabPane tab="Roles" key="/manage-roles" />
                )}
                {<TabPane tab="Departments" key="/manage-departments" />}
                {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP, Helpers.permissionTypes.READ, user) && <TabPane tab="User Policies" key="/manage-masking-policies" />}
              </Tabs>
              {key === '/manage-users' && (
                <div className="doc-list__wrapper doc-list__tab-content">
                  <div className="doc-list__table-wrapper">
                    <Table
                      title={() => (
                        <div className="doc-list__table-header">
                          <div className="doc-list__table-header__left">
                            {`${users?.data?.[0]?.tenant_user?.length || '0'} Team Members`}
                          </div>
                          <div className="doc-list__table-header__right">
                            <PRZSelect
                              value={selectedRole}
                              onChange={(value) => {
                                this.setState({ selectedRole: value });
                                getUsers(user?.tenant_info?.tenant_id, value);
                              }}
                              loading={getRolesLoading}
                              placeholder="Select Role"
                              style={{
                                width: '200px',
                                height: '32px',
                              }}
                            >
                              <Option key="" value=""> All Roles</Option>

                              {roles?.data?.map((role) => (
                                <Option key={role.tenant_role_id} value={role.tenant_role_id}>
                                  {' '}
                                  {role.tenant_role_name}
                                </Option>
                              ))}

                            </PRZSelect>
                            {Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.CREATE, user) && (
                              <div className="doc-list__buttons-wrapper">
                                <H3Button
                                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                  text="+ Add New User"
                                  onClick={() => this.setState({ showNewRoleModal: true })}
                                  customClass="add-button"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      showHeader
                      loading={getUsersLoading || updateUserLoading}
                      scroll={{
                        x: 'max-content',
                      }}
                      size="small"
                      columns={rolecolumns}
                      dataSource={users?.data?.[0]?.tenant_user || []}
                      currentPage
                      pagination={users?.data?.[0]?.tenant_user?.length > 10 ? {
                        defaultCurrent: 1,
                        pageSize: 10,
                        position: ['bottomRight'],
                        showSizeChanger: false,
                      } : false}
                      rowClassName={(record) => (!record?.is_active ? 'user-table__inactive' : '')}
                      bordered
                    />
                  </div>
                </div>
              )}
              {key === '/manage-roles' && <Roles />}
              {key === '/manage-departments' && <ListDepartment />}
              {key === '/manage-masking-policies' && <ListMaskingPolicies />}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  users: TenantReducers.users,
  getUsersLoading: UserReducers.getUsersLoading,
  updateUserLoading: UserReducers.updateUserLoading,
  roles: UserReducers.roles,
  getRolesLoading: UserReducers.getRolesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantId, roleId) => dispatch(TenantActions.getUsers(tenantId, roleId)),
  getRoles: (tenantId) => dispatch(UserActions.getRoles(tenantId)),
  updateUser: (payload, callback) => dispatch(UserActions.updateUser(payload, callback)),
  getUserProfile: (callback) => dispatch(UserActions.getUserProfile(callback)),
});

ManageRole.propTypes = {
  user: PropTypes.func,
  getUsers: PropTypes.func,
  getUsersLoading: PropTypes.bool,
  history: PropTypes.func,
  users: PropTypes.any,
  updateUserLoading: PropTypes.bool,
  updateUser: PropTypes.func,
  getRoles: PropTypes.func,
  roles: PropTypes.any,
  getRolesLoading: PropTypes.bool,
  location: PropTypes.any,
  getUserProfile: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withCustomHook(ManageRole)));
